













































































































































import { Component, Vue, Watch } from 'vue-property-decorator';
import cCard from '@/components/default/Card.vue';
import cPopup from '@/components/default/Popup.vue';
import { DxForm, DxSimpleItem, DxGroupItem, DxLabel, DxColCountByScreen } from 'devextreme-vue/form';
import { DxDataGrid, DxEditing, DxColumn, DxRequiredRule, DxStateStoring, DxColumnChooser, DxColumnFixing, DxLookup } from 'devextreme-vue/data-grid';
import { DxTextArea } from 'devextreme-vue/text-area';
import '@/types';
import notificationService from '@/services/notificationService';
import { DxNavBar, DxTextBox } from 'devextreme-vue';
import rawmaterialsRepository from '@/services/rawmaterialsRepository';
import { DxFileUploader } from 'devextreme-vue/file-uploader';
import settings from '@/settings.json';
import FilesTreeList from '@/components/varia/FilesTreeList.vue';
import {
  ContactBasicsDto,
  RawMaterialGroup,
  RawMaterialGroupsClient,
  SuppliersClient,
  RawMaterialsClient,
  CreateRawMaterialCommand,
  UpdateRawMaterialCommand,
  RawMaterialDto,
  RawMaterialTranslationDto,
} from '@/data/web-api-client';
import { RawMaterialStatusEnum } from '@/enums/rawMaterialStatusEnum';

Component.registerHooks(['beforeRouteLeave']);

@Component({
  components: {
    cCard,
    cPopup,
    DxNavBar,
    DxForm,
    DxSimpleItem,
    DxColumnChooser,
    DxColumnFixing,
    DxColumn,
    DxGroupItem,
    DxRequiredRule,
    DxLabel,
    DxTextArea,
    DxDataGrid,
    DxEditing,
    DxStateStoring,
    DxLookup,
    DxFileUploader,
    FilesTreeList,
    DxTextBox,
    DxColCountByScreen,
  },
})
export default class RawmaterialsDetails extends Vue {
  public rawmaterial: RawMaterialDto = new RawMaterialDto();
  public initialised: boolean = false;
  public navIndex: number = 0;
  translationsForm: any = {
    rawMaterialTranslations: [],
  };

  dirty: boolean = false;
  usages: any[] = [];
  selectedPricingRow: any = null;
  accessToken: string = '';
  suppliersClient: SuppliersClient = new SuppliersClient(undefined, this.$axios);
  suppliers: ContactBasicsDto[] = [];
  RawMaterialGroups: RawMaterialGroup[] = [];
  languages: any[] = [];
  rawMaterialsClient: RawMaterialsClient = new RawMaterialsClient(undefined, this.$axios);

  async loadData() {
    const self = this;

    // Load if we have an ID parameter
    if (this.$route.params.id) {
      this.rawmaterial = await this.rawMaterialsClient.getRawMaterial(this.$route.params.id);

      this.loadUsages();
    }

    setTimeout(() => {
      self.initialised = true;
    }, 200);
  }

  async created() {
    await this.getRawMaterialGroups();
    this.loadData();
    this.loadSuppliers();

    this.languages = this.$store.getters['catalogs/list']('Languages')?.values ?? [];

    this.accessToken = (await this.$auth.getAccessToken()) as string;
  }

  async copy() {
    const success = await this.$store.dispatch('rawmaterials/copy', this.rawmaterial!.id);
    this.initialised = false;
    if (success) {
      this.$router.push({ path: `/rawmaterials/${success}` });
      this.loadData();
    }
  }

  async loadUsages() {
    try {
      this.usages = (await rawmaterialsRepository.getUsage(this.$route.params.id)).data;
    } catch (err) {
      // do nothing
    }
  }

  beforeRouteLeave(to: any, from: any, next: any) {
    if (this.dirty) {
      if (confirm('Er zijn onopgeslagen wijzigingen. Bent u zeker dat u wenst te veranderen van pagina?')) {
        next();
      } else {
        next(false);
      }
    } else {
      next();
    }
  }

  async loadSuppliers() {
    this.suppliers = await this.suppliersClient.getAll();
  }

  get rawMaterialStatusOptions() {
    const items = [
      { value: RawMaterialStatusEnum.Active, text: 'Actief' },
      { value: RawMaterialStatusEnum.Disabled, text: 'Inactief' },
    ];

    return {
      dataSource: items,
      displayExpr: 'text',
      valueExpr: 'value',
      filterExpr: 'text',
    };
  }

  get RawMaterialGroupsOptions() {
    const items = this.RawMaterialGroups.map((mg) => ({
      value: mg.id,
      text: mg.name,
    }));

    return {
      dataSource: items,
      displayExpr: 'text',
      valueExpr: 'value',
      filterExpr: 'value',
    };
  }

  get measuringunitOptions() {
    const measuringUnits = this.$store.getters['measuringUnits/data'];

    return { items: measuringUnits ?? [] };
  }

  get measuringunitOptionsForPricing() {
    const measuringUnits = this.$store.getters['measuringUnits/data'];

    return measuringUnits ?? [];
  }

  get title() {
    return this.rawmaterial!.id ? this.$t('objects.rawmaterials.EditTitle') : this.$t('objects.rawmaterials.AddTitle');
  }

  get fileUploadSettings() {
    return {
      multiple: false,
      accept: '*',
      uploadUrl: `${settings.api}/api/Files/Upload/technical-file` + `?brand=${this.selectedPricingRow.brand}&id=${this.rawmaterial!.id}&kind=${this.selectedPricingRow.kind}`,
      uploadHeaders: {
        Authorization: `Bearer ${this.accessToken}`,
      },
      uploadMode: 'useButtons',
      objectId: null,
      files: [],
    };
  }

  get navbarItems() {
    return [
      { icon: 'fas fa-info-circle', text: 'Info' },
      { icon: 'fas fa-retweet', text: 'Conversies', visible: false },
      { icon: 'fas fa-list-ul', text: 'Producten' },
      { icon: 'fas fa-search', text: 'Gebruikt in' },
      { icon: 'fas fa-file-pdf', text: 'Technische fiches' },
    ];
  }

  get conversionsColumns() {
    return [
      {
        caption: 'A',
        columns: [
          {
            dataField: 'amountA',
            caption: 'Hoeveelheid',
            dataType: 'number',
            alignment: 'left',
          },
          {
            dataField: 'measuringUnitA',
            caption: 'Meeteenheid',
            lookup: {
              dataSource: this.measuringunitOptions.items,
            },
          },
        ],
      },
      {
        caption: 'B',
        columns: [
          {
            dataField: 'amountB',
            caption: 'Hoeveelheid',
            dataType: 'number',
            alignment: 'left',
          },
          {
            dataField: 'measuringUnitB',
            caption: 'Meeteenheid',
            lookup: {
              dataSource: this.measuringunitOptions.items,
            },
          },
        ],
      },
    ];
  }

  get columns() {
    return [
      {
        caption: 'Leverancier Info',
        columns: [
          {
            dataField: 'wholesaleId',
            caption: 'Leverancier',
            lookup: {
              dataSource: this.suppliers,
              displayExpr: 'displayName',
              valueExpr: 'id',
            },
            validationRules: [
              {
                type: 'required',
                message: this.$t('messages.FieldRequired', {
                  fieldname: this.$t('objects.rawmaterials.Pricing.Supplier'),
                }),
              },
            ],
          },
          {
            dataField: 'wholesaleRef',
            caption: this.$t('objects.rawmaterials.Pricing.Ref'),
          },
        ],
      },
      {
        caption: 'Stukinfo',
        columns: [
          {
            dataField: 'amount',
            caption: 'Aantal',
            dataType: 'number',
            alignment: 'left',
          },
          {
            dataField: 'measuringUnit',
            caption: 'Meeteenheid',
            lookup: {
              dataSource: this.measuringunitOptionsForPricing,
            },
          },
          {
            dataField: 'minimumQuantity',
            caption: 'Min. bestelstuks',
            alignment: 'left',
          },
        ],
      },
      {
        caption: 'Product Info',
        columns: [
          {
            dataField: 'brand',
            caption: 'Merk',
          },
          {
            dataField: 'kind',
            caption: 'Soort',
          },
        ],
      },
      {
        caption: 'Conversie',
        columns: [
          {
            dataField: 'convertAmountA',
            caption: 'Hoeveelheid',
            dataType: 'number',
            alignment: 'left',
            calculateDisplayValue: (rowData: IWholesalePricing) => {
              if (rowData.convertAmountA) {
                return `${rowData.convertAmountA} ${rowData.measuringUnit}`;
              }
              return '';
            },
          },
          {
            dataField: 'convertAmountB',
            caption: 'Hoeveelheid in ' + this.rawmaterial!.measuringUnit,
            dataType: 'number',
            alignment: 'left',
            calculateDisplayValue: (rowData: IWholesalePricing) => {
              if (rowData.convertAmountB) {
                return `${rowData.convertAmountB} ${this.rawmaterial!.measuringUnit}`;
              }
              return '';
            },
          },
        ],
      },
      {
        dataField: 'default',
        caption: this.$t('objects.rawmaterials.Pricing.Default'),
        dataType: 'boolean',
      },
      {
        caption: this.$t('objects.rawmaterials.Pricing.PurchasePrice'),
        columns: [
          {
            dataField: 'purchaseAmount',
            caption: 'Aantal',
            dataType: 'number',
            alignment: 'left',
            calculateDisplayValue: (rowData: IWholesalePricing) => {
              if (rowData.purchaseAmount) {
                return `${rowData.purchaseAmount} ${rowData.measuringUnit}`;
              }
              return '';
            },
          },
          {
            dataField: 'purchasePrice',
            caption: 'B2B',
            dataType: 'number',
            alignment: 'left',
            format: { style: 'currency', currency: 'EUR', useGrouping: true },
          },
          {
            dataField: 'purchasePricePrivate',
            caption: 'B2C',
            dataType: 'number',
            alignment: 'left',
            format: { style: 'currency', currency: 'EUR', useGrouping: true },
          },
        ],
      },
      {
        caption: this.$t('objects.rawmaterials.Pricing.SellingPrice'),
        columns: [
          {
            dataField: 'salesPriceOrganisation',
            caption: 'B2B',
            dataType: 'number',
            alignment: 'left',
            format: { style: 'currency', currency: 'EUR', useGrouping: true },
            allowEditing: false,
          },
          {
            dataField: 'salesPricePrivate',
            caption: 'B2C',
            dataType: 'number',
            alignment: 'left',
            format: { style: 'currency', currency: 'EUR', useGrouping: true },
            allowEditing: false,
          },
        ],
      },
      {
        dataField: 'purchasePriceDefaultMeasuringUnit',
        caption: 'Prijs per ' + this.rawmaterial!.measuringUnit,
        dataType: 'number',
        calculateDisplayValue: (item: any) => {
          if (!item || !item.purchasePriceDefaultMeasuringUnit) {
            return '€ 0';
          }
          const val = Math.round(item.purchasePriceDefaultMeasuringUnit * 10000) / 10000;
          return `€ ${val}`;
        },
        allowEditing: false,
      },
      {
        type: 'buttons',
        buttons: [
          {
            hint: 'Upload Technische Fiche',
            icon: 'fas fa-file-upload',
            // visible: this.isCloneIconVisible,
            onClick: this.startUpload,
          },
          'edit',
          'delete',
        ],
      },
    ];
  }

  startUpload(e: any) {
    this.selectedPricingRow = e.row.data;
  }

  createRow(e: any) {
    const self = this;

    e.cancel = new Promise(async (resolve, reject) => {
      try {
        const data = e.data;

        if (!data.salesPricePrivate || data.salesPricePrivate === 0) {
          data.salesPricePrivate = Math.round(data.purchasePrice * (100 + self.rawmaterial!.margin!)) / 100;
        }
        if (!data.salesPriceOrganisation || data.salesPriceOrganisation === 0) {
          data.salesPriceOrganisation = Math.round(data.purchasePrice * (100 + self.rawmaterial!.margin!)) / 100;
        }

        if (data.default) {
          self.rawmaterial!.pricing!.forEach((element) => {
            element.default = false;
          });
        }

        self.rawmaterial!.pricing!.push(data);

        await self.save();

        const table: any = self.$refs.pricingtable;
        table.instance.cancelEditData();

        resolve(true);
      } catch (err) {
        notificationService.failedToSave();
        reject(true);
      }
    });
  }

  addPrice() {
    const table: any = this.$refs.pricingtable;
    table.instance.addRow();
  }

  addConversion() {
    const table: any = this.$refs.conversionstable;
    table.instance.addRow();
  }

  updateRow(e: any) {
    const self = this;
    e.cancel = new Promise(async (resolve, reject) => {
      try {
        if (!e.oldData.default && e.newData.default) {
          // set all others to not default
          self.rawmaterial!.pricing!.forEach((element) => {
            element.default = false;
          });
        }

        if (e.newData.purchasePrice) {
          e.newData.salesPrice = Math.round(e.newData.purchasePrice * (100 + self.rawmaterial!.margin!)) / 100;
          e.newData.salesPriceOrganisation = Math.round(e.newData.purchasePrice * (100 + self.rawmaterial!.margin!)) / 100;
        }

        const pricing = self.rawmaterial!.pricing!.find((o: any) => o === e.oldData);
        if (pricing) {
          Object.assign(pricing, e.newData);
        }

        await self.save();
        resolve(false);
      } catch (err) {
        notificationService.failedToSave();
        reject(false);
      }
    });
  }

  async save() {
    let success = true;

    if (this.rawmaterial?.id) {
      const command = UpdateRawMaterialCommand.fromJS(this.rawmaterial);

      command.translations = this.translationsForm.rawMaterialTranslations.map((t: any) =>
        RawMaterialTranslationDto.fromJS({
          language: t.language,
          name: t.name,
          description: t.description,
        })
      );

      try {
        await this.rawMaterialsClient.putRawMaterial(command);

        success = true;
      } catch (err) {
        notificationService.failedToSave();
      }
    } else {
      const command = CreateRawMaterialCommand.fromJS(this.rawmaterial);

      command.translations = this.translationsForm.rawMaterialTranslations.map((t: any) =>
        RawMaterialTranslationDto.fromJS({
          language: t.language,
          name: t.name,
          description: t.description,
        })
      );

      try {
        const result = await this.rawMaterialsClient.postRawMaterial(command);

        success = true;

        this.dirty = false;
        this.initialised = false;
        this.$router.push({ path: `/rawmaterials/${result.id!}` });
        this.loadData();
      } catch (err) {
        notificationService.failedToSave();
      }
    }

    if (success) {
      this.dirty = false;
    }
  }

  async getRawMaterialGroups() {
    try {
      const res = await new RawMaterialGroupsClient(undefined, this.$axios).getAll();

      this.RawMaterialGroups = res;
    } catch (err) {
      notificationService.failedToLoad();
    }
  }

  get worktypesOptions() {
    const catalog = this.$store.getters['catalogs/list']('WorkTypes');
    const items = catalog ? catalog.values : [];
    return { items };
  }

  get translationsGroup() {
    const items: any[] = [];

    for (let index = 0; index < this.languages.length; index++) {
      this.translationsForm.rawMaterialTranslations[index] = {
        language: this.languages[index],
        name: '',
        description: '',
      };

      const existingTranslation = this.rawmaterial?.translations?.find((t) => t.language == this.languages[index]);

      if (existingTranslation) {
        this.translationsForm.rawMaterialTranslations[index].name = existingTranslation.name;
        this.translationsForm.rawMaterialTranslations[index].description = existingTranslation.description;
      }

      items.push({
        itemType: 'group',
        caption: this.languages[index],
        items: [
          {
            itemType: 'simple',
            dataField: `rawMaterialTranslations[${index}].name`,
            label: {
              text: this.$t('objects.rawmaterials.Name'),
            },
          },
          {
            itemType: 'simple',
            dataField: `rawMaterialTranslations[${index}].description`,
            label: {
              text: this.$t('objects.rawmaterials.Description'),
            },
          },
        ],
      });
    }

    return items;
  }

  @Watch('rawmaterial', { deep: true })
  onRawmaterialChanged() {
    // alert("changed")
    if (this.initialised) {
      this.dirty = true;
    }
  }
}

/*
  TODO:
  - save on form update
*/
